<template lang="html">
  <div
    id="locationModal"
    @click="closeModal"
    class="location modal fade"
    data-backdrop="false"
    tabindex="-1"
    role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content p-2">
        <button type="button"
                @click="resetValues"
                class="close location-close"
                data-dismiss="modal"
                aria-label="Close">
          <font-awesome-icon :icon="[ 'fas', 'times' ]" />
        </button>
        <div class="modal-body text-center">
          <h4 class="text-secondary"><b>¿Dónde querés buscar?</b></h4>
          <SquaredButton
            class="btn-block my-3"
            @click="detectLocation"
            type="button"
            styleType="primary"
            noUpperCase
            label="Detectar automáticamente" />
          <div class="my-3" style="position: relative;">
            <GmapCheckable
              v-show="editLocation"
              @focus="isEditing = true"
              @blur="handleBlur"
              gMapId="newLocationGMapAutocomplete"
              :placesTypes="'(cities)'"
              textDisabled
              noCheckbox
              @textChanged="setPlace" />
            <div v-if="!editLocation" @click="handleEdit" style="cursor: pointer;">
              <CheckableText
                :value="filterLocation(filtersCity)"
                noCheckbox
                editable
                textDisabled />
            </div>
            <Loading :active="isFetching" small />
          </div>
          <SquaredButton
            class="my-3"
            @click="close"
            type="button"
            styleType="primary"
            noUpperCase
            label="Cerrar" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import store from '@/store'
import GmapCheckable from '@/components/ui/forms/GmapCheckable'
import { asyncDetect ,fetchCity, mapDefaultDistance } from '@/location'
import { trunkFloat, filterLocation } from '@/helpers'

export default {
  components: {
    GmapCheckable
  },

  data: () => ({
    nextCity: {
      lat: '',
      lon: '',
      city: ''
    },
    nextDistance: '',
    restrictions: {
      country: ['ar']
    },
    isFetching: false,
    editLocation: false
  }),

  computed: {
    isAuth: () => store.state.user.isAuth,

    filtersLocation: () => store.getters['filters/location'],

    filtersCity () { return filterLocation(this.filtersLocation.city) },

    distance: () => store.state.search.distance,

    lat: () => this.filtersLocation.lat,

    lon: () => this.filtersLocation.lon,

    person: () => store.state.user.person,

    userInfo () {
      return {
        person: this.person,
        preferred_location: {
          city: this.filtersCity,
          search_distance: this.distance,
          latitude: String(this.lat),
          longitude: String(this.lon)
        }
      }
    }
  },

  methods: {
    trunkFloat,
    filterLocation,
    fetchCity,
    mapDefaultDistance,

    setPlace (place) {
      if (!place || Object.keys(place).length <= 1) return
      this.isFetching = true
      const latLon = {
        lat: trunkFloat(place.geometry.location.lat()),
        lon: trunkFloat(place.geometry.location.lng())
      }
      // Get the city from Google, using lat & lon
      this.fetchCity(latLon)
        .then(loc => {
          this.nextCity.lat = parseFloat(loc.lat)
          this.nextCity.lon = parseFloat(loc.lon)
          this.nextCity.city = filterLocation(loc.city)
          // Gets the default distance for a given city
          this.nextDistance = mapDefaultDistance(this.nextCity.city)
          this.pushToDataLayer('Location dialog', 'Change location')
          // Returns Promise
          return this.setChanges()
        })
        .then(() => { this.handleBlur() })
        .catch(er => { console.warn(er) })
        .finally(() => { this.isFetching = false })
    },

    setChanges () {
      if (this.nextCity.city) {
        const promises = [
          // Update filter location
          store.dispatch('filters/setLocation', this.nextCity),
          // With sync = true, the preferred location will be updated if the user is logged in
          store.dispatch('setLocation', {coords: this.nextCity, sync: true})
        ]
        // Resolves when both promises are finished
        return Promise.all(promises)
      } else {
        return Promise.reject(new Error('City could not be fetched'))
      }
    },

    detectLocation () {
      asyncDetect()
        .then((loc) => {
          this.nextCity = loc
          this.pushToDataLayer('Location dialog', 'Detect location')
          this.setChanges()
            .then(this.close)
        })
        .catch(err => {
          console.warn('could not detect location') })
    },

    resetValues () {
      document.getElementById('newLocationGMapAutocomplete').value = ''
      this.nextCity = {
        lat: '',
        lon: '',
        city: ''
      }
      this.nextDistance = ''
    },

    closeModal (e) {
      if (e.target === this.$el) {
        this.close()
      }
      else
        e.stopPropagation()
    },

    close () {
      $(this.$el).modal('hide')
      this.resetValues()
    },

    handleEdit () {
      this.editLocation = true
      // Get the autocomplete input element and focus on it
      const gMapInput = document.getElementById('newLocationGMapAutocomplete')
      this.$nextTick(() => {
        gMapInput.focus()
        gMapInput.setAttribute('autocomplete', 'off')
      })
    },

    handleBlur () {
      this.isEditing = false
      this.editLocation = false
    }
  },

  mounted () {
    this.resetValues()
  }
}
</script>

<style lang="scss">
  @import '../../scss/colors';

  #locationModal{
    background-color: rgba(0, 0, 0, 0.5);
  }

  .location-close {
    position: absolute;
    top: 0.6rem;
    right: 1rem;
    z-index: 4;
  }

  .pac-container {
    z-index: 1051;
  }

  .pac {
    &-item {
      line-height: 35px !important;

      &-query {
        font-size: 1rem !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/LocationDialog.vue